import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { RideTypeService } from 'src/app/services/ride-type.service';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    imports: [
        AnalyticsDirective,
        AngularSvgIconModule,
        AsyncPipe,
        RouterLink,
        RouterLinkActive,
    ],
    selector: 'rdx-primary-nav',
    styleUrls: ['./primary-nav.component.scss'],
    templateUrl: './primary-nav.component.html',
})
export class PrimaryNavComponent implements OnInit {
    homeUrl: string;
    brand: string;
    garageIcon: string;
    isEpi: boolean;
    isAuthenticated: boolean;
    isMapTypeSno$: Observable<boolean>;
    loggedOutGarageUrl: string;
    rideCommandPlusUrl: string;

    constructor(
        configService: ConfigService,
        routingHelpersService: RoutingHelpersService,
        private rideTypeService: RideTypeService,
        userAuthService: UserAuthService
    ) {
        this.brand = configService.brand;
        this.rideCommandPlusUrl = routingHelpersService.getUrlWithCulture(
            '/ride-command-plus/'
        );
        this.isEpi = configService.isEmbedded;

        userAuthService.isAuthenticated$.subscribe((isAuthenticated) => {
            this.isAuthenticated = isAuthenticated;
            if (this.isEpi && !isAuthenticated) {
                this.homeUrl = configService.siteUrl;
                this.loggedOutGarageUrl = routingHelpersService.combineUrl(
                    configService.siteUrl,
                    'garage/'
                );
            }
        });
    }

    ngOnInit(): void {
        this.isMapTypeSno$ = this.rideTypeService.isSnoRideType$;
    }
}
